// The exit survey, shown after submitting.
//
// Anonymous, and said so plainly: an applicant asked whether they struggled with an
// application they have just submitted for judging gives a different answer if they think it
// is attached to their name.

import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api.ts';
import { Notice, ErrorNotice, Field, TextArea } from '../components/Bits.tsx';

export function Difficulties({ year }: { year: number }) {
  const [problems, setProblems] = useState('');
  const [done, setDone] = useState(false);

  const save = useMutation({
    mutationFn: () => api.post('/api/survey/difficulties', { problems }),
    onSuccess: () => setDone(true),
  });

  if (done) {
    return (
      <Notice kind="ok">
        Thank you!
      </Notice>
    );
  }

  return (
    <div className="panel">
      <h3 style={{ marginTop: 0 }}>Help us improve next year's application</h3>
      <p className="hint">
        Did anything about this application give you trouble? This is completely anonymous —
        it is not linked to your name or your application, and it has no bearing on the
        outcome. It is only read when the {year + 1} application is being prepared.
      </p>

      <ErrorNotice error={save.error} />

      <form onSubmit={(e) => { e.preventDefault(); save.mutate(); }}>
        <Field label="Anything that was confusing, broken, or harder than it needed to be">
          <TextArea
            value={problems}
            style={{ minHeight: '7rem' }}
            onChange={(e) => setProblems(e.target.value)}
          />
        </Field>
        <div className="actions">
          <button type="submit" disabled={save.isPending || !problems.trim()}>
            {save.isPending ? 'Sending…' : 'Send'}
          </button>
          <button type="button" className="quiet" onClick={() => setDone(true)}>
            No thanks
          </button>
        </div>
      </form>
    </div>
  );
}
